import { render, staticRenderFns } from "./default-avatar.vue?vue&type=template&id=d5db4da6"
import script from "./default-avatar.vue?vue&type=script&lang=js"
export * from "./default-avatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports